import React, { useState, useEffect } from 'react';
import SearchableDropdown from '../../../components/common/SearchableDropdown';
import API_BASE_URL from '../../../components/apiconfig/api-config';
import { formatDateDDMMYY } from '../../../components/common/dateUtils';

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  console.log('Testing formatDateDDMMYY with:', dateStr);
  const result = formatDateDDMMYY(dateStr);
  console.log('Result:', result);
  return result;
};

const A4PrintPreview = ({ formData, onBack, sellers, commodities, autoPrint = false }) => {
  const supplierName = sellers.find(s => s.supplier_id === formData.supplierId)?.name || '';
  const commodityName = commodities.find(c => c.commodity_id === formData.commodityId)?.name || '';
  const [isReadyToPrint, setIsReadyToPrint] = useState(false);

  useEffect(() => {
    // Add print styles
    const style = document.createElement('style');
    style.textContent = `
      @media print {
        @page {
          size: A4 portrait;
          margin: 10mm;
        }
        body {
          background: #fff !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        .a4-print-container {
          width: 210mm !important;
          min-height: 297mm !important;
          margin: 0 auto !important;
          box-shadow: none !important;
          background: #fff !important;
          padding: 15px !important;
          page-break-inside: avoid !important;
        }
        .no-print {
          display: none !important;
        }
        * {
          -webkit-print-color-adjust: exact !important;
          color-adjust: exact !important;
        }
      }
    `;
    document.head.appendChild(style);

    // Mark as ready after styles are applied
    setTimeout(() => {
      setIsReadyToPrint(true);
    }, 200);

    // Cleanup function
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Auto print when component is ready and autoPrint is enabled
  useEffect(() => {
    if (autoPrint && isReadyToPrint) {
      setTimeout(() => {
        window.print();
      }, 300);
    }
  }, [autoPrint, isReadyToPrint]);

  return (
    <div style={{
      background: '#f8fafc',
      minHeight: '100vh',
      padding: '20px 0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
      <div style={{
        background: '#fff',
        width: '1600px',
        minHeight: '1123px',
        padding: '15px',
      }} className="a4-print-container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 32 }}>
          <img src={require('../../../assets/logo-kribhcoAgri.png')} alt="Logo" style={{ height: 60 }} />
          <div>
            <button onClick={onBack} style={{ 
              marginRight: 16, 
              padding: '8px 20px', 
              background: '#3899cf', 
              color: '#fff', 
              border: '1px solid #3899cf', 
              borderRadius: 4, 
              fontWeight: 600, 
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }} onMouseOver={e => e.currentTarget.style.background = '#0e8dc6'} onMouseOut={e => e.currentTarget.style.background = '#3899cf'}>Back to Form</button>
            <button onClick={() => window.print()} disabled={!isReadyToPrint} style={{
              padding: '8px 20px',
              background: isReadyToPrint ? '#3899cf' : '#9CA3AF',
              color: '#fff',
              border: `1px solid ${isReadyToPrint ? '#3899cf' : '#9CA3AF'}`,
              borderRadius: 4,
              fontWeight: 600,
              cursor: isReadyToPrint ? 'pointer' : 'not-allowed',
              transition: 'all 0.3s ease'
            }} onMouseOver={e => {
              if (isReadyToPrint) e.currentTarget.style.background = '#0e8dc6';
            }} onMouseOut={e => {
              if (isReadyToPrint) e.currentTarget.style.background = '#3899cf';
            }}>
              {isReadyToPrint ? 'Print' : 'Loading...'}
            </button>
          </div>
        </div>
        <h2 style={{ 
          textAlign: 'center', 
          marginBottom: 24, 
          fontSize: 28, 
          fontWeight: 700, 
          letterSpacing: 1,
          color: '#1e3a8a'
        }}>Marine Insurance Policy</h2>
        
        <div style={{ 
          border: '1px solid #e2e8f0',
          borderRadius: '8px',
          overflow: 'hidden',
          marginBottom: 24
        }}>
          <table style={{ 
            width: '100%', 
            borderCollapse: 'collapse',
            fontSize: 14
          }}>
            <tbody>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0',
                  width: '30%'
                }}>Policy Number</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0',
                  fontWeight: 500
                }}>{formData.policyNumber || 'To be assigned'}</td>
              </tr>
              <tr>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Buyer</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.buyerName}</td>
              </tr>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Seller</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{supplierName}</td>
              </tr>
              <tr>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>State of Purchase</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.stateOfPurchase}</td>
              </tr>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Address</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.buyerAddress}</td>
              </tr>
              <tr>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Purchase Contract</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.contractNo}</td>
              </tr>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Commodity</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{commodityName}</td>
              </tr>
              <tr>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Total Qty (MT)</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.totalQtyMt}</td>
              </tr>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Unit Price (USD)</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.unitPriceUsd}</td>
              </tr>
              <tr>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Vessel Name</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.vesselName}</td>
              </tr>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Departure Date</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formatDate(formData.departureDate)}</td>
              </tr>
              <tr>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>ETA Port</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.etaPort}</td>
              </tr>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Arrival Date</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formatDate(formData.arrivalDate)}</td>
              </tr>
              <tr>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Loading Port</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.loadingPort}</td>
              </tr>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Destination Port</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.destinationPort}</td>
              </tr>
              <tr>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Contract No./Date</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.contractNoDate}</td>
              </tr>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Quantity (MT)</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.quantity}</td>
              </tr>
              <tr>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Rate</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.rate}</td>
              </tr>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Amount US $</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.amountUSD}</td>
              </tr>
              <tr>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Amount INR (Approx Rate)</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.amountINR}</td>
              </tr>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>USD × INR (Product)</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.amountUSD && formData.amountINR ? (parseFloat(formData.amountUSD) * parseFloat(formData.amountINR)).toFixed(2) : ''}</td>
              </tr>
              <tr>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Mark up/Expenses @ (%)</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.markupPercent}</td>
              </tr>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Mark up/Expenses Value</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>{formData.markup}</td>
              </tr>
              <tr>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0'
                }}>Total Value</td>
                <td style={{ 
                  padding: '12px 16px',
                  borderBottom: '1px solid #e2e8f0',
                  fontWeight: 600,
                  color: '#1e40af'
                }}>{formData.totalValue}</td>
              </tr>
              <tr style={{ backgroundColor: '#f8fafc' }}>
                <td style={{ 
                  fontWeight: 600, 
                  padding: '12px 16px'
                }}>GST No</td>
                <td style={{ 
                  padding: '12px 16px'
                }}>{formData.gstNo}</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        {/* Insurance Premium Calculation */}
        {formData.insurancePremium && (
          <div style={{
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '24px',
            backgroundColor: '#f0f9ff'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: 600,
              marginBottom: '12px',
              color: '#0369a1'
            }}>Insurance Premium Calculation</h3>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span>Premium ( Total Value):</span>
              <span style={{ fontWeight: 500 }}>₹{formData.insurancePremium}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span>Add-on Amount:</span>
              <span style={{ fontWeight: 500 }}>₹{formData.addOnAmount || '0.00'}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span>GST (18%):</span>
              <span style={{ fontWeight: 500 }}>₹{formData.gst}</span>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '12px',
              paddingTop: '8px',
              borderTop: '1px dashed #cbd5e1'
            }}>
              <span style={{ fontWeight: 600 }}>Total Premium Payable:</span>
              <span style={{ fontWeight: 600, color: '#1e40af' }}>₹{formData.totalPremium}</span>
            </div>
            <div style={{
              marginTop: '12px',
              paddingTop: '8px',
              borderTop: '1px solid #cbd5e1'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 500 }}>Type:</span>
                <span style={{ fontWeight: 500, color: '#0369a1' }}>{formData.insuranceType || ''}</span>
              </div>
            </div>
          </div>
        )}
        
        <div style={{ 
          textAlign: 'right', 
          marginTop: 40,
          paddingTop: '40px',
          borderTop: '1px solid #e2e8f0'
        }}>
          <div style={{ fontWeight: 600, fontSize: 16, marginBottom: '60px' }}>
            <div>For KRIBHCO</div>
            <div style={{ marginTop: '40px' }}>
              <div style={{ borderTop: '1px solid #000', width: '200px', display: 'inline-block' }}></div>
              <div style={{ marginTop: '4px' }}>Authorized Signatory</div>
            </div>
          </div>
          <div style={{ 
            fontSize: 12, 
            color: '#64748b',
            textAlign: 'left',
            marginTop: '40px'
          }}>
            <div style={{ fontWeight: 600, marginBottom: '4px' }}>Note:</div>
            <div>1. This is a computer generated document and does not require signature.</div>
            <div>2. Please make payment within 7 days of receiving this document.</div>
          </div>
        </div>
      </div>
    </div>
  );
};
const MarineInsuranceForm = () => {
  const [buyers, setBuyers] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [contracts, setContracts] = useState([]);
    // Removed import orders state
  const [commodities, setCommodities] = useState([]);
  const [billOfLadingsAll, setBillOfLadingsAll] = useState([]);
  const [formData, setFormData] = useState({});
  const [showPreview, setShowPreview] = useState(false);
  const [activeSection, setActiveSection] = useState('basic');
  const [contractsAll, setContractsAll] = useState([]);

  // On mount, fetch all data
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/insurance/insurance-form-data`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        console.log('Fetched data:', data);
        setSellers(data.suppliers || []);
        setBuyers(data.kribhcoDetails || []);
        setContractsAll(data.contracts || []);
        setCommodities(data.commodities || []);
        // No longer need to set import orders
        setBillOfLadingsAll(data.billOfLadings || []);
        console.log('Import orders loaded:', data.importOrders);
      });
  }, []);

  // Calculate Amount USD when quantity or rate changes
  useEffect(() => {
    const quantity = parseFloat(formData.quantity) || 0;
    const rate = parseFloat(formData.rate) || 0;
    
    // Don't update if manually edited
    if (formData.manualAmountUSD) return;
    
    if (quantity && rate) {
      const amountUSD = (quantity * rate).toFixed(2);
      setFormData(prev => ({
        ...prev,
        amountUSD: amountUSD
      }));
    }
  }, [formData.quantity, formData.rate, formData.manualAmountUSD]);

  // useEffect(() => {
  //   const amountUSD = parseFloat(formData.amountUSD) || 0;
  //   const amountINR = (amountUSD * USD_TO_INR).toFixed(2);
  //   setFormData(prev => ({
  //     ...prev,
  //     amountINR: amountUSD ? amountINR : ''
  //   }));
  // }, [formData.amountUSD]);

  useEffect(() => {
    // Skip auto-calculation if user has manually set usdInrProduct
    if (formData.manualUsdInrProduct) return;
    
    const amountUSD = parseFloat(formData.amountUSD) || 0;
    const amountINR = parseFloat(formData.amountINR) || 0;
    
    if (amountUSD && amountINR) {
      const product = amountUSD * amountINR;
      setFormData(prev => ({
        ...prev,
        usdInrProduct: product.toFixed(2)
      }));
    }
  }, [formData.amountUSD, formData.amountINR, formData.manualUsdInrProduct]);

  useEffect(() => {
    // Skip auto-calculation if user has manually set markup
    if (formData.manualMarkup) return;
    
    const product = parseFloat(formData.usdInrProduct) || 0;
    const percent = parseFloat(formData.markupPercent) || 0;
    
    if (product && percent) {
      const markupValue = ((product * percent) / 100).toFixed(2);
      setFormData(prev => ({
        ...prev,
        markup: markupValue
      }));
    }
  }, [formData.usdInrProduct, formData.markupPercent, formData.manualMarkup]);

  useEffect(() => {
    // Skip auto-calculation if user has manually set totalValue
    if (formData.manualTotalValue) return;
    
    const usdInrProduct = parseFloat(formData.usdInrProduct) || 0;
    const markup = parseFloat(formData.markup) || 0;
    
    if (usdInrProduct || markup) {
      const totalValue = usdInrProduct + markup;
      setFormData(prev => ({
        ...prev,
        totalValue: totalValue.toFixed(2)
      }));
    }
  }, [formData.usdInrProduct, formData.markup, formData.manualTotalValue]);

  // On supplier change, filter contracts
  const handleSupplierChange = (supplierId) => {
    setFormData(prev => ({
      ...prev,
      supplierId,
      contractNo: '',
    }));
    const filteredContracts = contractsAll.filter(c => c.supplier_id === supplierId);
    setContracts(filteredContracts);
  };

  const handleContractChange = (contractNo) => {
    setFormData(prev => ({ ...prev, contractNo }));
    
    const contract = contracts.find(c => c.purchase_contract_no === contractNo);
    if (contract) {
      // Find relevant bill of lading if available
      const relevantBL = billOfLadingsAll.find(bl => bl.purchase_contract_no === contractNo) || {};
      
      // Auto-fill data but preserve any existing values
      setFormData(prev => {
        // Reset manual edit flags with a new contract
        const resetFlags = {
          manualAmountUSD: false,
          manualUsdInrProduct: false,
          manualMarkup: false,
          manualTotalValue: false
        };

        return {
          ...prev,
          contractNo: contract.purchase_contract_no,
          contractDate: contract.contract_date,
          contractNoDate: contract.purchase_contract_no + ' / ' + contract.contract_date,
          commodityId: contract.commodity_id,
          supplierId: contract.supplier_id,
          // Always auto-fill these fields from contract, can be manually changed later
          quantity: contract.total_qty_mt ? Number(contract.total_qty_mt).toFixed(3) : '',
          rate: contract.unit_price_usd ? Number(contract.unit_price_usd).toFixed(2) : '',
          vesselName: prev.vesselName || relevantBL.vessel_name || '',
          etaPort: prev.etaPort || relevantBL.eta_port || '',
          loadingPort: prev.loadingPort || relevantBL.loading_port || '',
          destinationPort: prev.destinationPort || relevantBL.destination_port || '',
          ...resetFlags
        };
      });
    }
  };


   const handleBuyerChange = (buyerId) => {
    const buyer = buyers.find(b => b.id === buyerId);
    setFormData(prev => ({
      ...prev,
      buyerId,
      buyerName: buyer ? buyer.business_name : '',
      stateOfPurchase: buyer ? buyer.state : '',
      buyerAddress: buyer ? buyer.address : '',
      gstNo: buyer ? buyer.gst_number : '',
    }));
  };
 const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Set flags for manually edited values to prevent auto-calculation
    if (name === 'amountUSD') {
      setFormData(prev => ({ ...prev, [name]: value, manualAmountUSD: true }));
    } else if (name === 'usdInrProduct') {
      setFormData(prev => ({ ...prev, [name]: value, manualUsdInrProduct: true }));
    } else if (name === 'markup') {
      setFormData(prev => ({ ...prev, [name]: value, manualMarkup: true }));
    } else if (name === 'totalValue') {
      setFormData(prev => ({ ...prev, [name]: value, manualTotalValue: true }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  
  // Calculate insurance premium
  const totalValue = parseFloat(formData.totalValue) || 0;
  const insuranceRate = (parseFloat(formData.insuranceRate) || 0.032) / 100;
  const insurancePremium = (totalValue * insuranceRate).toFixed(0);
  const addOnAmount = parseFloat(formData.addOnAmount) || 0;
  const gst = ((parseFloat(insurancePremium) + addOnAmount) * 0.18).toFixed(0);
  const totalPremium = (parseFloat(insurancePremium) + addOnAmount + parseFloat(gst)).toFixed(0);
  
  const usdInrProduct = formData.amountUSD && formData.amountINR 
    ? (parseFloat(formData.amountUSD) * parseFloat(formData.amountINR)).toFixed(2)
    : null;
  
  const updatedFormData = {
    ...formData,
    insurancePremium,
    gst,
    totalPremium,
    usdInrProduct,
    addOnAmount: addOnAmount.toFixed(2),
    insuranceType: formData.insuranceType || ''
  };
  
  setFormData(updatedFormData);
  
  try {
    // Helper function to format date for database (YYYY-MM-DD)
    const formatDateForDB = (dateStr) => {
      if (!dateStr) return null;
      
      // If it's already in YYYY-MM-DD format (from date picker)
      if (typeof dateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        return dateStr;
      }
      
      // If it's already in ISO format (from auto-filled data)
      if (dateStr.includes('T')) {
        return dateStr.split('T')[0];
      }
      
      // If it's in DD/MM/YY format (manually entered)
      if (dateStr.includes('/')) {
        const parts = dateStr.split('/');
        if (parts.length === 3) {
          const day = parts[0].padStart(2, '0');
          const month = parts[1].padStart(2, '0');
          let year = parts[2];
          
          // Convert 2-digit year to 4-digit
          if (year.length === 2) {
            year = parseInt(year) < 50 ? '20' + year : '19' + year;
          }
          
          return `${year}-${month}-${day}`;
        }
      }
      
      return null;
    };

    // Prepare data for API
    const insuranceData = {
      buyer_id: formData.buyerId,
      supplier_id: formData.supplierId,
      contract_no: formData.contractNo,
      commodity_id: formData.commodityId,
      loading_port: formData.loadingPort,
      destination_port: formData.destinationPort,
      quantity: formData.quantity,
      rate: formData.rate,
      amount_usd: formData.amountUSD,
      amount_inr: formData.amountINR,
      usd_inr_product: usdInrProduct,
      markup_percent: formData.markupPercent,
      markup: formData.markup,
      total_value: formData.totalValue,
      insurance_premium: insurancePremium,
      gst: gst,
      total_premium: totalPremium,
      gst_no: formData.gstNo,
      policy_number: formData.policyNumber,
      add_on_amount: formData.addOnAmount || '0.00',
      type: formData.insuranceType || '',
      departure_date: formatDateForDB(formData.departureDateManual),
      arrival_date: formatDateForDB(formData.arrivalDateManual),
      vessel_name: formData.vesselName,
      eta_port: formData.etaPort,
      created_by: 1
    };
    
    console.log('Date values being sent:', {
      departureDate: formData.departureDate,
      departureDateManual: formData.departureDateManual,
      arrivalDate: formData.arrivalDate,
      arrivalDateManual: formData.arrivalDateManual,
      formattedDeparture: formatDateForDB(formData.departureDate || formData.departureDateManual),
      formattedArrival: formatDateForDB(formData.arrivalDate || formData.arrivalDateManual)
    });
    
    // Call API to save data
    const response = await fetch(`${API_BASE_URL}/api/insurance/marine-insurance`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(insuranceData)
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to save insurance data');
    }
    
    const result = await response.json();
    console.log('Insurance saved successfully:', result);
    
    alert('Insurance policy saved successfully!');
    setShowPreview(true);
    
  } catch (error) {
    console.error('Error saving insurance data:', error);
    alert('Error saving insurance data: ' + error.message);
  }
};

  if (showPreview) {
    return <A4PrintPreview
      formData={formData}
      onBack={() => setShowPreview(false)}
      sellers={sellers}
      commodities={commodities}
      autoPrint={false}
    />;
  }


  return (
   <div className="max-w-8xl mx-auto p-2 bg-white rounded border border-gray-100">
      {/* Header section remains the same */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Marine Insurance Calculator</h2>
          <p className="text-gray-600">Fill in the details to calculate insurance premium</p>
        </div>
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <label className="text-sm font-medium text-gray-700">Insurance Rate:</label>
            <input 
              name="insuranceRate" 
              value={formData.insuranceRate || '0.032'} 
              onChange={handleChange} 
              className="w-20 px-2 py-1 text-sm border border-gray-300 rounded focus:border-blue-500 focus:ring-1 focus:ring-blue-500" 
              placeholder="0.032"
            />
            <span className="text-sm text-gray-600">%</span>
          </div>
        </div>
      </div>

      {/* Tab navigation remains the same */}
      <div className="mb-6">
        <div className="flex border-b border-gray-200">
          <button
            className={`py-2 px-4 font-medium ${activeSection === 'basic' ? 'text-[#3899cf] border-b-2 border-[#3899cf]' : 'text-gray-500 border-b-2 border-transparent'}`}
            onClick={() => setActiveSection('basic')}
          >
            Basic Details
          </button>
          <button
            className={`py-2 px-4 font-medium ${activeSection === 'contract' ? 'text-[#3899cf] border-b-2 border-[#3899cf]' : 'text-gray-500 border-b-2 border-transparent'}`}
            onClick={() => setActiveSection('contract')}
          >
            Contract Details
          </button>
          <button
            className={`py-2 px-4 font-medium ${activeSection === 'calculation' ? 'text-[#3899cf] border-b-2 border-[#3899cf]' : 'text-gray-500 border-b-2 border-transparent'}`}
            onClick={() => setActiveSection('calculation')}
          >
            Premium Calculation
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Basic Details Section */}
        {(activeSection === 'basic') && (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Buyer (Kribhco)</label>
                <SearchableDropdown
                  options={buyers}
                  value={formData.buyerId || ''}
                  onChange={handleBuyerChange}
                  placeholder="Select Buyer"
                  displayKey="business_name"
                  valueKey="id"
                  required
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Seller (Supplier)</label>
                <SearchableDropdown
                  options={sellers}
                  value={formData.supplierId || ''}
                  onChange={handleSupplierChange}
                  placeholder="Select Supplier"
                  displayKey="name"
                  valueKey="supplier_id"
                  required
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  State of Purchase
                  {!formData.stateOfPurchase && <span className="text-xs text-gray-500 ml-2">(editable)</span>}
                </label>
                <input
                  name="stateOfPurchase"
                  value={formData.stateOfPurchase || ''}
                  onChange={handleChange}
                  placeholder="Enter state of purchase"
                  className={`block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 ${
                    formData.stateOfPurchase ? 'bg-gray-50' : 'bg-white'
                  }`}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  GST No
                  {!formData.gstNo && <span className="text-xs text-gray-500 ml-2">(auto-filled from buyer)</span>}
                </label>
                <input
                  name="gstNo"
                  value={formData.gstNo || ''}
                  onChange={handleChange}
                  placeholder="GST Number"
                  className={`block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 ${
                    formData.gstNo ? 'bg-gray-50' : 'bg-white'
                  }`}
                  readOnly={!!formData.gstNo}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Address
                  {!formData.buyerAddress && <span className="text-xs text-gray-500 ml-2">(editable)</span>}
                </label>
                <input
                  name="buyerAddress"
                  value={formData.buyerAddress || ''}
                  onChange={handleChange}
                  placeholder="Enter buyer address"
                  className={`block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 ${
                    formData.buyerAddress ? 'bg-gray-50' : 'bg-white'
                  }`}
                />
              </div>
            </div>

            <div className="flex justify-end">
              <button 
                type="button" 
                onClick={() => setActiveSection('contract')}
                className="inline-flex items-center px-4 py-2 border border-[#3899cf] text-sm font-medium rounded-md shadow-sm text-white bg-[#3899cf] hover:bg-[#0e8dc6] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3899cf]"
              >
                Next: Contract Details
                <svg className="ml-2 -mr-1 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        )}

        {/* Contract Details Section */}
        {(activeSection === 'contract') && (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Purchase Contract</label>
                <SearchableDropdown
                  options={contracts}
                  value={formData.contractNo || ''}
                  onChange={handleContractChange}
                  placeholder="Select Contract"
                  displayKey="purchase_contract_no"
                  valueKey="purchase_contract_no"
                  required
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Commodity
                  {!formData.commodityId && <span className="text-xs text-gray-500 ml-2">(type if not auto-filled)</span>}
                </label>
                <input
                  name="commodityName"
                  value={formData.commodityId ? 
                    commodities.find(c => c.commodity_id === formData.commodityId)?.name || '' : 
                    formData.commodityName || ''}
                  onChange={handleChange}
                  placeholder="Enter commodity name"
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Supplier ID</label>
                <input 
                  name="supplierId" 
                  value={formData.supplierId || ''} 
                  onChange={handleChange} 
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" 
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Quantity (MT)
                </label>
                <input 
                  name="quantity" 
                  value={formData.quantity || ''} 
                  onChange={handleChange}
                  placeholder="Enter quantity in MT"
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Rate (USD/MT)
                </label>
                <input 
                  name="rate" 
                  value={formData.rate || ''} 
                  onChange={handleChange}
                  placeholder="Enter unit price in USD"
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Vessel Name
                  {!formData.vesselName && <span className="text-xs text-gray-500 ml-2">(editable)</span>}
                </label>
                <input 
                  name="vesselName" 
                  value={formData.vesselName || ''} 
                  onChange={handleChange}
                  placeholder="Enter vessel name"
                  className={`block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 ${
                    formData.vesselName ? 'bg-gray-50' : 'bg-white'
                  }`}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Departure Date
                  {!formData.departureDate && <span className="text-xs text-gray-500 ml-2">(editable)</span>}
                </label>
                <input 
                  type="date"
                  name="departureDateManual" 
                  value={formData.departureDateManual || ''} 
                  onChange={handleChange}
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  ETA Port
                  {!formData.etaPort && <span className="text-xs text-gray-500 ml-2">(editable)</span>}
                </label>
                <input 
                  name="etaPort" 
                  value={formData.etaPort || ''} 
                  onChange={handleChange}
                  placeholder="Enter ETA port"
                  className={`block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 ${
                    formData.etaPort ? 'bg-gray-50' : 'bg-white'
                  }`}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Arrival Date
                  {!formData.arrivalDate && <span className="text-xs text-gray-500 ml-2">(editable)</span>}
                </label>
                <input 
                  type="date"
                  name="arrivalDateManual" 
                  value={formData.arrivalDateManual || ''} 
                  onChange={handleChange}
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Loading Port</label>
                <input 
                  name="loadingPort" 
                  value={formData.loadingPort || ''} 
                  onChange={handleChange}
                  placeholder="Enter loading port"
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" 
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Destination Port</label>
                <input 
                  name="destinationPort" 
                  value={formData.destinationPort || ''} 
                  onChange={handleChange}
                  placeholder="Enter destination port"
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" 
                />
              </div>
            </div>

              <div className="flex justify-between">
              <button 
                type="button" 
                onClick={() => setActiveSection('basic')}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                <svg className="mr-2 -ml-1 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
                </svg>
                Back
              </button>
              <button 
                type="button" 
                onClick={() => setActiveSection('calculation')}
                className="inline-flex items-center px-4 py-2 border border-[#3899cf] text-sm font-medium rounded-md shadow-sm text-white bg-[#3899cf] hover:bg-[#0e8dc6] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3899cf]"
              >
                Next: Premium Calculation
                <svg className="ml-2 -mr-1 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        )}

        {/* Premium Calculation Section */}
        {(activeSection === 'calculation') && (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Amount US $</label>
                <input 
                  name="amountUSD" 
                  value={formData.amountUSD || ''} 
                  onChange={handleChange} 
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" 
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Amount INR (Approx Rate)</label>
                <input 
                  name="amountINR" 
                  value={formData.amountINR || ''} 
                  onChange={handleChange} 
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" 
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">USD × INR (Product)</label>
                <input
                  name="usdInrProduct"
                  value={
                    formData.amountUSD && formData.amountINR
                      ? (parseFloat(formData.amountUSD) * parseFloat(formData.amountINR)).toFixed(2)
                      : formData.usdInrProduct || ''
                  }
                  onChange={handleChange}
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Mark up/Expenses @ (%)</label>
                <input 
                  name="markupPercent" 
                  value={formData.markupPercent || ''} 
                  onChange={handleChange} 
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" 
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Mark up/Expenses Value</label>
                <input 
                  name="markup" 
                  value={formData.markup || ''} 
                  onChange={handleChange}
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" 
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Total Value</label>
                <input
                  name="totalValue"
                  value={formData.totalValue || ''}
                  onChange={handleChange}
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 font-semibold text-blue-800"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Policy No</label>
                <input
                  name="policyNumber"
                  value={formData.policyNumber || ''}
                  onChange={handleChange}
                  placeholder="Enter Policy Number"
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Add-on Amount</label>
                <input
                  name="addOnAmount"
                  type="number"
                  step="0.01"
                  value={formData.addOnAmount || ''}
                  onChange={handleChange}
                  placeholder="0.00"
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Add-on Type</label>
                <input
                  name="insuranceType"
                  type="text"
                  value={formData.insuranceType || ''}
                  onChange={handleChange}
                  placeholder="Enter add-on type"
                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="bg-blue-50 p-4 rounded-lg border border-blue-100">
              <h3 className="text-lg font-medium text-blue-800 mb-2">Premium Estimate</h3>
              {formData.totalValue ? (
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-700">Estimated Premium ({(parseFloat(formData.insuranceRate) || 0.032)}%):</span>
                    <span className="font-medium">₹{(parseFloat(formData.totalValue) * (parseFloat(formData.insuranceRate) || 0.032) / 100).toFixed(0)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-700">Estimated GST (18%):</span>
                    <span className="font-medium">₹{(parseFloat(formData.totalValue) * (parseFloat(formData.insuranceRate) || 0.032) / 100 * 0.18).toFixed(0)}</span>
                  </div>
                  <div className="flex justify-between pt-2 border-t border-blue-200">
                    <span className="text-gray-700 font-medium">Total Estimated Premium:</span>
                    <span className="font-bold text-blue-800">
                      ₹{(parseFloat(formData.totalValue) * (parseFloat(formData.insuranceRate) || 0.032) / 100 * 1.18).toFixed(0)}
                    </span>
                  </div>
                </div>
              ) : (
                <p className="text-gray-600">Complete the form to see premium calculation</p>
              )}
            </div>

            {/* Calculation Breakdown */}
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
              <h3 className="text-lg font-medium text-gray-800 mb-3">Calculation Breakdown</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Quantity:</span>
                    <input 
                      type="text" 
                      className="w-24 text-right font-medium border-none bg-transparent" 
                      value={`${formData.quantity || 0} MT`} 
                      readOnly
                    />
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Rate:</span>
                    <input 
                      type="text" 
                      className="w-24 text-right font-medium border-none bg-transparent" 
                      value={`$${formData.rate || 0}/MT`} 
                      readOnly
                    />
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Amount USD:</span>
                    <input 
                      type="text" 
                      className="w-24 text-right font-medium border-none bg-transparent" 
                      value={`$${formData.amountUSD || 0}`} 
                      readOnly
                    />
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Amount INR:</span>
                    <input 
                      type="text" 
                      className="w-24 text-right font-medium border-none bg-transparent" 
                      value={`₹${formData.amountINR || 0}`} 
                      readOnly
                    />
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-600">USD × INR Product:</span>
                    <input 
                      type="text" 
                      className="w-24 text-right font-medium border-none bg-transparent" 
                      value={`₹${formData.usdInrProduct || 0}`} 
                      readOnly
                    />
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Markup %:</span>
                    <input 
                      type="text" 
                      className="w-24 text-right font-medium border-none bg-transparent" 
                      value={`${formData.markupPercent || 0}%`} 
                      readOnly
                    />
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Markup Value:</span>
                    <input 
                      type="text" 
                      className="w-24 text-right font-medium border-none bg-transparent" 
                      value={`₹${formData.markup || 0}`} 
                      readOnly
                    />
                  </div>
                  <div className="flex justify-between">
                    <span className="font-semibold text-blue-800">Total Value:</span>
                    <input 
                      type="text" 
                      className="w-24 text-right font-semibold text-blue-800 border-none bg-transparent" 
                      value={`₹${formData.totalValue || 0}`} 
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="mt-3 pt-3 border-t border-gray-300">
                <div className="text-xs text-gray-500">
                  <strong>Formula:</strong> Total Value = (Amount USD × Amount INR) + Markup Value
                </div>
              </div>
            </div>

            <div className="flex justify-between">
              <button 
                type="button" 
                onClick={() => setActiveSection('contract')}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                <svg className="mr-2 -ml-1 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
                </svg>
                Back
              </button>
              <button 
                type="submit" 
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-[#3899cf] hover:bg-[#0e8dc6] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#3899cf]"
              >
                Generate Insurance Document
                <svg className="ml-2 -mr-1 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        )}
      </form>
    </div>
  );
};

export default MarineInsuranceForm;